var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 12.784c0-.886-.08-1.739-.227-2.557H12.5v4.835h6.727a5.75 5.75 0 0 1-2.494 3.773v3.137h4.04c2.363-2.177 3.727-5.381 3.727-9.188Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 25c3.375 0 6.204-1.12 8.273-3.028l-4.04-3.137c-1.12.75-2.551 1.193-4.233 1.193-3.256 0-6.011-2.198-6.994-5.153H1.329v3.239A12.495 12.495 0 0 0 12.5 25Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.506 14.875a7.515 7.515 0 0 1-.392-2.375c0-.824.142-1.625.392-2.375V6.886H1.33A12.495 12.495 0 0 0 0 12.5c0 2.017.483 3.926 1.33 5.614l4.176-3.239Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4.972c1.835 0 3.483.63 4.778 1.869l3.585-3.585C18.7 1.239 15.87 0 12.5 0A12.495 12.495 0 0 0 1.33 6.886l4.176 3.239C6.489 7.17 9.244 4.972 12.5 4.972Z",
    fill: "#EA4335"
  })));
};
export default SvgGoogle;